import type { ISpProfilePublic, PatchSpDemographicsInput } from '@brushfire/types'
import {
  formatUsMobileDisplay,
  normalizeUsMobileForStorage,
} from '@/features/account/lib/account-phone-utils'
import type { AccountSettingsFormData } from './account-settings-schema'

export function profileToFormValues(profile: ISpProfilePublic): AccountSettingsFormData {
  return {
    firstName: profile.firstName ?? '',
    lastName: profile.lastName ?? '',
    email: profile.email ?? '',
    phone: formatUsMobileDisplay(profile.phone),
    dateOfBirth: profile.dateOfBirth ?? '',
    gender: profile.gender ?? '',
    maritalStatus: profile.maritalStatus ?? '',
    state: profile.locationData?.state ?? '',
    city: profile.locationData?.city ?? '',
    householdSize: profile.householdSize ?? '',
    numberOfChildren: profile.numberOfChildren ?? '',
    education: profile.education ?? '',
    employment: profile.employment ?? '',
    industry: profile.industry ?? '',
    housingStatus: profile.housingStatus ?? '',
  }
}

export function formToPatchPayload(
  values: AccountSettingsFormData,
  options?: { omitNameFields?: boolean },
): PatchSpDemographicsInput {
  const payload: PatchSpDemographicsInput = {
    phone: normalizeUsMobileForStorage(values.phone),
    dateOfBirth: values.dateOfBirth,
    gender: values.gender,
    maritalStatus: values.maritalStatus,
    state: values.state,
    city: values.city,
    householdSize: values.householdSize,
    numberOfChildren: values.numberOfChildren,
    education: values.education,
    employment: values.employment,
    industry: values.industry,
    housingStatus: values.housingStatus,
  }
  if (!options?.omitNameFields) {
    payload.firstName = values.firstName.trim()
    payload.lastName = values.lastName.trim()
  }
  return payload
}
